import type { FormEvent, MouseEvent } from 'react';

const handleDomBubbleEvent = <T extends HTMLElement>(e: MouseEvent<T> | FormEvent<T>) => {
  e.stopPropagation();
  e.preventDefault();
};

export { handleDomBubbleEvent };
